module.exports = __webpack_public_path__ + "static/media/photo8str.670eb315.jpg";